export const PASSWORD_REQUIREMENTS_STRINGS = {
  title: 'Password requirements:',
  length: 'At least 8 characters',
  uppercase: 'At least one uppercase letter',
  lowercase: 'At least one lowercase letter',
  digit: 'At least one digit',
} as const
